// @flow
import typeof { resources } from 'node/resources/routes';

export type ResourceName = $Keys<resources>;

export type Payload = {
  name: ResourceName,
  nextBookmark?: string,
  options: Object,
  data?: any,
  isPrefetch?: boolean,
};

export type ResourceInvalidate = {
  type: 'RESOURCE_INVALIDATE',
  payload: { name: ResourceName, options: Object },
};
export function resourceInvalidate<Name: ResourceName>(
  name: Name,
  options: Object = {},
): ResourceInvalidate {
  return {
    type: 'RESOURCE_INVALIDATE',
    payload: { name, options },
  };
}

export type ResourceFetch = {
  type: 'RESOURCE_FETCH',
  payload: {
    name: ResourceName,
    options: Object,
    moduleRenderOptions: Object,
    headers: Object,
    traceLoggerHandlerName?: string,
  },
};

export function resourceFetch<Name: ResourceName>(
  name: Name,
  options: Object = {},
  moduleRenderOptions: Object = {},
  headers: Object = {},
  traceLoggerHandlerName?: string = '',
): ResourceFetch {
  return {
    type: 'RESOURCE_FETCH',
    payload: { name, options, moduleRenderOptions, headers, traceLoggerHandlerName },
  };
}

export type ResourcePrefetch = {
  type: 'RESOURCE_PREFETCH',
  payload: {
    name: ResourceName,
    options: Object,
    moduleRenderOptions: Object,
    headers: Object,
    traceLoggerHandlerName?: string,
  },
};

export function resourcePrefetch<Name: ResourceName>(
  name: Name,
  options: Object = {},
  moduleRenderOptions: Object = {},
  headers: Object = {},
  traceLoggerHandlerName?: string,
): ResourcePrefetch {
  return {
    type: 'RESOURCE_PREFETCH',
    payload: { name, options, moduleRenderOptions, headers, traceLoggerHandlerName },
  };
}

export type ResourcePrefetchRead = {
  type: 'RESOURCE_PREFETCH_READ',
  payload: {
    name: ResourceName,
    options: Object,
  },
};

export function resourcePrefetchRead<Name: ResourceName>(
  name: Name,
  options: Object = {},
): ResourcePrefetchRead {
  return {
    type: 'RESOURCE_PREFETCH_READ',
    payload: { name, options },
  };
}

export type ResourceFetchMore = {
  type: 'RESOURCE_FETCH_MORE',
  payload: {
    name: ResourceName,
    options: Object,
    moduleRenderOptions: Object,
    headers: Object,
    traceLoggerHandlerName?: string,
  },
};

export function resourceFetchMore<Name: ResourceName>(
  name: Name,
  options: Object = {},
  moduleRenderOptions: Object = {},
  headers: Object = {},
  traceLoggerHandlerName?: string = '',
): ResourceFetchMore {
  return {
    type: 'RESOURCE_FETCH_MORE',
    payload: { name, options, moduleRenderOptions, headers, traceLoggerHandlerName },
  };
}

export type ResourceFetchCreate = {
  type: 'RESOURCE_FETCH_CREATE',
  payload: { name: ResourceName, options: Object },
};

export function resourceFetchCreate<Name: ResourceName>(
  name: Name,
  options: Object = {},
): ResourceFetchCreate {
  return {
    type: 'RESOURCE_FETCH_CREATE',
    payload: { name, options },
  };
}

export type ResourceFetchComplete = {
  type: 'RESOURCE_FETCH_COMPLETE',
  payload: Payload,
  error?: Error,
};

export function resourceFetchComplete<Name: ResourceName>(
  name: Name,
  options: Object = {},
  data?: any,
  error?: any,
  nextBookmark?: string,
  isPrefetch?: boolean = false,
): ResourceFetchComplete {
  return {
    type: 'RESOURCE_FETCH_COMPLETE',
    payload: {
      name,
      nextBookmark,
      options,
      data,
      isPrefetch,
    },
    error,
  };
}

export type ResourceFetchMoreComplete = {
  type: 'RESOURCE_FETCH_MORE_COMPLETE',
  payload: Payload,
  error?: Error,
};

export function resourceFetchMoreComplete<Name: ResourceName>(
  name: Name,
  options: Object = {},
  data?: any,
  error?: any,
  nextBookmark?: string,
): ResourceFetchMoreComplete {
  return {
    type: 'RESOURCE_FETCH_MORE_COMPLETE',
    payload: {
      name,
      nextBookmark,
      options,
      data,
    },
    error,
  };
}
